import React from 'react'
import Tooltip from 'components/Luxkit/Tooltip'
import Group from 'components/utils/Group'
import SolidInfoCircleIcon from 'components/Luxkit/Icons/solid/SolidInfoCircleIcon'
import BodyText from 'components/Luxkit/Typography/BodyText'

interface Props {
  children: React.ReactNode
  tooltip?: string
}

function ExperienceTicketInfoMessage(props: Props) {
  return (
    <Tooltip description={props.tooltip} disabled={!props.tooltip}>
      <Group direction="horizontal" gap={2}>
        <BodyText colour="neutral-two" variant="small">{props.children}</BodyText>
        {!!props.tooltip && <SolidInfoCircleIcon size="XS" />}
      </Group>
    </Tooltip>
  )
}

export default ExperienceTicketInfoMessage
